<template>
  <div id="propertyDetails">

    <div class="section-content" ref="scrollArea">
    
      <template v-if="selected">
      
        <div class="vo-card">
        
          <div class="vo-header">
            Property Details
          </div>
          <div class="vo-content">

            <div class="vo-s-list">
              <div class="name">Property</div>
              <div class="value">{{ selected.name }}</div>
            </div>

            <div class="vo-s-list">
              <div class="name">Address</div>
              <div class="value">
                <div><span v-if="selected.address.line2">{{ selected.address.line2 }} - </span>{{ selected.address.line1 }}</div>
                <div>{{ selected.address.city }}, {{ selected.address.province }} {{ selected.address.country }}</div>
                <div>{{ selected.address.postal }}</div>
              </div>
            </div>

          </div>
          <div class="vo-footer">
            <v-btn flat class="vo-button" @click="routeAddQueries({ dialog: 'property-manage', dialogAction: 'edit' })">
              <v-icon>mdi-pencil</v-icon>
              <span>Edit</span>
            </v-btn>
            <v-btn flat class="vo-button red" @click="deletePropertyDialog">
              <v-icon>mdi-delete</v-icon>
              <span>Delete</span>
            </v-btn>
          </div>
        </div>
 
        <!-- EXPORT -->
        <div class="vo-card" v-if="hasPermissionsInProperty(['ticketAdmin'])">
          <div class="vo-header">
            Generate Report
          </div>
          <div class="vo-content">
            
            <div>
              <div>From:</div>
              <v-menu
                ref="fromDateInput"
                lazy
                :close-on-content-click="false"
                v-model="report.fromDateMenu"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                min-width="290px"
                :return-value.sync="report.fromDate.date"
              >
                <v-text-field
                  ref="fromDateTextInput"
                  slot="activator"
                  label="Click to select date"
                  v-model="report.fromDate.date"
                  prepend-icon="event"
                  readonly
                  :rules="rules.report"
                ></v-text-field>
                <v-date-picker v-model="report.fromDatePicker" color="primary" no-title scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="report.fromDateMenu = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.fromDateInput.save(report.fromDatePicker)">OK</v-btn>
                </v-date-picker>
              </v-menu>
              <v-menu
                ref="fromTimeInput"
                lazy
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
                :return-value.sync="report.fromDate.time"
              >
                <v-text-field
                  slot="activator"
                  label="Click to select time"
                  v-model="report.fromDate.time"
                  prepend-icon="access_time"
                  readonly
                ></v-text-field>
                <v-time-picker v-model="report.fromTimePicker" color="primary" @change="$refs.fromTimeInput.save(report.fromTimePicker)"></v-time-picker>
              </v-menu>

              <br>
              <div>To:</div>
              <v-menu
                ref="toDateInput"
                lazy
                :close-on-content-click="false"
                v-model="report.toDateMenu"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                min-width="290px"
                :return-value.sync="report.toDate.date"
              >
                <v-text-field
                  slot="activator"
                  label="Click to select date"
                  v-model="report.toDate.date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="report.toDatePicker" no-title color="primary" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="report.toDateMenu = false">Cancel</v-btn>
                  <v-btn flat color="primary" @click="$refs.toDateInput.save(report.toDatePicker)">OK</v-btn>
                </v-date-picker>
              </v-menu>
              <v-menu
                ref="toTimeInput"
                lazy
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
                :return-value.sync="report.toDate.time"
              >
                <v-text-field
                  slot="activator"
                  label="Click to select time"
                  v-model="report.toDate.time"
                  prepend-icon="access_time"
                  readonly
                ></v-text-field>
                <v-time-picker color="primary" v-model="report.toTimePicker" @change="$refs.toTimeInput.save(report.toTimePicker)"></v-time-picker>
              </v-menu>
            </div>

            <v-btn class="button" :loading="report.lockout" color="primary" @click="generateReport()">download report</v-btn>
            <div class="clear"></div>

          </div>
        </div>

        <div class="vo-card">
          <div class="vo-header">Manager Tools</div>
          <div class="tools">
            <div v-if="hasPermissionsInProperty(tool.permissions, selected._id)" v-ripple class="tool" v-for="(tool, key) in managerTools" @click="openManagerTool(tool)" :key="key">
              <v-icon class="tool-icon">{{ tool.icon }}</v-icon>
              <div class="name">{{ tool.name }}</div>
              <v-icon class="chevron">mdi-chevron-right</v-icon>
              <div class="clear"></div>
            </div>
          </div>
        </div>

        <div class="vo-card">
          <div class="vo-header">Default Assignees</div>
          <div class="vo-content">

            <div v-if="Object.keys(statuses).length > 0" class="status" v-for="(status, key) in statuses" :key="key">

              <v-select
                autocomplete
                multiple
                item-text="fullName"
                item-value="_id"
                @keyup="searchAssignees(key, status.searchText)"
                @change="changeAssignee(key, $event)"
                :disabled="statusLockout !== false"
                :label="status.name"
                :loading="status.loading || statusLockout === status"
                :items="status.searchResults"
                :search-input.sync="status.searchText"
                v-model="status.assignees">
            
                <template slot="selection" slot-scope="data">
                  <div class="vo-user-chip">
                    <vo-avatar class="avatar" :user="data.item" :size="24"></vo-avatar>
                    <div class="name">{{ data.item.fullName }}</div>
                    <v-btn class="btn" fab flat small @click="removeAssignee(key, data.item, $event)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </template>

              </v-select>

            </div>
            <div v-else>
              <v-progress-circular style="margin: 0 auto;" indeterminate color="primary" :size="40"></v-progress-circular>
            </div>

          </div>
        </div>

        <!-- UNIT TYPES -->
        <div class="vo-card" v-if="hasPermissionsInProperty(['unit'], this.selected._id)">
          <div class="vo-header">
            Unit Types
            <div class="vo-actions">
              <v-btn flat fab small class="vo-icon-button" @click="routeAddQuery('dialog', 'unit-type-manage')">
                <v-icon medium>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
          <div>
            <vo-list v-if="page.unitTypes.list" class="list" :list="page.unitTypes.list">
              <div class="unit-type" slot-scope="item" slot="itemSlot">
                
                <div class="name">{{ $store.getters.unitType(item.item).name }}</div>
                <div class="buttons">
                  <v-btn fab small flat class="vo-icon-button" @click="openEditDialog(item)">
                    <v-icon medium>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn fab small flat class="vo-icon-button" @click="deleteUnitTypeDialog(item)">
                    <v-icon medium>mdi-delete</v-icon>
                  </v-btn>
                </div>
      
              </div>
            </vo-list>
          </div>
        </div>

      </template>

      <template v-else>
        <vo-empty-state text="SELECT A PROPERTY"></vo-empty-state>
      </template>
    </div>

    <vo-details-header></vo-details-header>

  </div>
</template>

<script>

  import DetailsMixin from '../mixins/detailsMixin.js';
  import permissionMixin from '../mixins/permissionMixin.js';
  import fileSaver from 'file-saver';
  import _ from 'lodash'

  export default {
    mixins: [DetailsMixin, permissionMixin],
    data () {
      return {
        report: {
          fromMenu            : false,
          fromDatePicker      : null,
          toMenu              : false,
          toDatePicker        : null,
          toDate              : {
            date                : null,
            time                : null
          },
          fromDate            : {
            date                : null,
            time                : null
          },
          dateInvalid         : false,
          lockout             : false
        },
        timeouts: {
          assignables: false,
          unitTypes: false
        },
        managerTools : [
          {
            icon: 'mdi-ticket',
            name: 'View Tickets',
            route: 'tickets',
            permissions: ['ticket', 'ticketManager', 'ticketAdmin']
          },
          {
            icon: 'mdi-account-multiple',
            name: 'View People',
            route: 'joined',
            permissions: ['user']
          },
          {
            icon: 'mdi-home',
            name: 'View Units',
            route: 'units',
            permissions: ['unit']
          },
        ],
        statuses: {},
        statusLockout: false,
        rules: {
          report: [
            function (e) {
              if (this.report.dateInvalid) {
                this.report.dateInvalid = false;

                return 'From date must be before To date.';
              }
              
              return true;
            }.bind(this)
          ]
        }
      }
    },
    
    methods: {
      searchAssignees: _.debounce(function (status, value) {
        
        this.statuses[status].loading = true;
        this.$store.dispatch('loadAssignableUsers', {
          property: this.selected._id,
          filters: {
            search: value
          }
        })
        .then(data => {
          
          this.statuses[status].assignees.forEach(assignee => {
            if (data.indexOf(assignee) < 0) {
              data.push(assignee);
            }
          })

          this.statuses[status].searchResults = data;
          this.statuses[status].loading = false;
        })
        .catch(e => {
          this.statuses[status].searchResults = [];
          this.statuses[status].searchLoading = false;
        });

      }, 200),

      openManagerTool (tool) {
        this.$router.push({
          name: tool.route
        });

        this.$nextTick(() => {
          Vue.set(this.app.pages[tool.route].filtering.filters.property, 'value', this.selected._id);
        });
      },

      openEditDialog (item) {
        this.routeAddQueries({ dialog: 'unit-type-manage', dialogItem: item.item, dialogAction: 'edit' });
      },

      // DIALOGS

      deletePropertyDialog () {

        Dialog.showDialog({
          title: 'Delete Property',
          body: 'To delete a property, please contact Vilio support.',
          confirm: {
            title: 'CONTACT SUPPORT',
            action: () => {
              window.open(window.urls.support, '_blank');
              return Promise.resolve();
            }
          }
        });
      },

      deleteUnitTypeDialog (item) {

        Dialog.showDialog({
          title: 'Delete Unit Type',
          body: 'Are you sure you want to delete this unit type?',
          confirm: {
            title: 'Delete',
            action: () => {

              return this.$store.dispatch('deleteUnitType', {
                unitType: item.item,
                property: this.page.selected
              })
              .then(data => {
                this.page.unitTypes.list.removeItem(item.item);

                // Reinit Filters to reflect changes
                window.AppData.initFilters();
                
                Toast.show('Unit Type deleted.', 'success');
                return Promise.resolve();
              })
              .catch(e => {

                if (e.error.code === 40027) {
                  Toast.show('Unit Type in use. You must remove this Unit Type from all units before deleting it.', 'failure', {
                    duration: 8000
                  });
                }
                else {
                  console.log(e);
                  Toast.showError(e);
                }
                return Promise.reject();
              });
            }
          }
        });
      },

      loadProperty () {
        this.selectFromDetails(this.page, 'loadProperty', {
          property: this.$route.query.details
        });
      },

      changeAssignee (status, e) {
        if (this.statusLockout) return;

        // Someone was added
        if (e.length > this.selected.statuses[status].assignees.length) {
          var added = e.filter(x => !this.selected.statuses[status].assignees.includes(x));
          this.addAssignee(status, added);
        }

        // Someone was removed
        else if (e.length < this.selected.statuses[status].assignees.length) {
          var removed = this.selected.statuses[status].assignees.filter(x => !e.includes(x));
          this.removeAssignee(status, this.$store.getters.user(removed[0]));
        }

      },

      addAssignee (status, user, e) {
        if (this.statusLockout) return;
        this.statusLockout = status;

        this.$store.dispatch('addPropertyAssignee', {
          status: status,
          property: this.selected._id,
          assignees: user
        })
        .then(data => {          
          Toast.show('Assignee added.', 'success');
          this.statusLockout = false;
        })
        .catch(e => {
          this.statusLockout = false;
          Toast.showError(e);
          console.log(e);          
        })
      },

      removeAssignee (status, user, e) {
        if (e) e.stopPropagation();
        if (this.statusLockout) return;
        this.statusLockout = status;

        this.$store.dispatch('removePropertyAssignee', {
          status: status,
          property: this.selected._id,
          assignees: [user._id]
        })
        .then(data => {

          var index = this.statuses[status].assignees.indexOf(user._id);
          if (index >= 0) {
            this.statuses[status].assignees.splice(index, 1);
          } 
          
          Toast.show('Assignee removed.', 'success');
          this.statusLockout = false;
        })
        .catch(e => {
          this.statusLockout = false;
          Toast.showError(e);
          console.log(e);          
        })
      },

      generateReport () {
        this.report.lockout = true;

        var from  = window.moment(this.report.fromDate.date + ' ' + this.report.fromDate.time).valueOf();
        var to    = window.moment(this.report.toDate.date + ' ' + this.report.toDate.time).valueOf();

        if (to < from) {
          Toast.show('Please correct the highlighted errors.', 'error');
          this.report.dateInvalid = true;
          this.report.lockout = false;
          this.$refs.fromDateTextInput.validate(true);
          return;
        }

        this.$store.dispatch('ticketSummaryReport', {
          property    : this.selected._id,
          from        : from,
          to          : to
        })
        .then(data => {          
          Toast.show('Report generating...', 'success');
          fileSaver.saveAs(new Blob([data], { type: 'text/csv' }), 'summary.csv');
          this.report.lockout = false;
        })
        .catch(e => {
          this.report.lockout = false;
          Toast.showError(e);
          console.log(e);          
        })
      },


      loadAssignables () {

        this.$store.dispatch('loadAssignableUsers', {
          property: this.selected._id,
          filters: {
            search: ''
          }
        })
        .then(data => {
          var defaultItems = data;

          // Set Statuses
          var unordered = {...this.selected.statuses};
          var statuses = {};

          Object.keys(this.$store.getters.company.statuses).forEach(function(key) {
            if (key in unordered) {
              statuses[key] = unordered[key];
            }
          });
          
          for (var status in statuses) {
            

            statuses[status] = {
              ...statuses[status],
              name: status.toUpperCase(),
              searchText: '',
              searchResults: [...defaultItems, ...statuses[status].assignees],
              searchLoading: false
            };

            Vue.set(this, 'statuses', statuses);
          };
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
        });

      },

      loadUnitTypes () {

        // Reset Unit Types
        if (this.page.unitTypes.property !== this.selected._id) {
          
          if (this.page.unitTypes.list) this.page.unitTypes.list.clearList();

          if (this.hasPermissionsInProperty(['unit'], this.selected._id)) {

            // Create Unit Types list
            this.page.unitTypes.property = this.selected._id; // This enforces that the list will only reset when a new property is selected
            Vue.set(this.page.unitTypes, 'list', new ListModel(this.page.unitTypes.listParams));
            
            // Set Params - Being watched by List.vue, will load itself
            this.page.unitTypes.list.params = {
              property: this.selected._id
            };
          }
        }
      },

      loadPropertyItems () {
        if (this.timeouts.assignables) clearTimeout(this.timeouts.assignables);
        if (this.timeouts.unitTypes)   clearTimeout(this.timeouts.unitTypes);

        this.timeouts.assignables  = setTimeout(this.loadAssignables, (window.cordova ? 600 : 1)); 
        this.timeouts.unitTypes    = setTimeout(this.loadUnitTypes, (window.cordova ? 700 : 1));
      }

    },

    computed: {

      selected () {
        return this.$store.getters.property(this.page.selected);
      }

    },

    watch: {
      
      'selected' () {
        
        // Check Property is Set
        if (!this.selected || (this.lastSelected && this.selected._id === this.lastSelected._id)) return;

        // Scroll to top
        if (this.lastSelected && this.lastSelected._id !== this.selected._id) {
          this.$refs.scrollArea.scrollTop = 0;
        }

        this.loadPropertyItems();
        
        this.lastSelected = this.selected;
      },

      '$route.query.details' () {
        this.loadProperty();
      }
      
    },

    created () {
      this.loadProperty();
      if (this.selected) this.loadPropertyItems();

      var dateObj = moment().startOf('month');
      this.report.fromDate.date = dateObj.format('YYYY-MM-DD');
      this.report.fromDate.time = dateObj.format('HH:mm');

      dateObj = moment().endOf('month');
      this.report.toDate.date = dateObj.format('YYYY-MM-DD');
      this.report.toDate.time = dateObj.format('HH:mm');
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #propertyDetails {
    
    @include fontPrimary400();

    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
      
    .section-content {
      @include scrollContainer();
      top: 48px;

      background: $lightGreen; 
      padding: 16px;
      box-sizing: border-box;
    }
  
    .list__tile__mask {
      color: red !important;
    }

    .vo-card {

      .tools {

        .tool {
          
          cursor: pointer;

          &:not(:last-of-type) {
            border-bottom: $borderBlack12;
          }

          .tool-icon {
            float: left;
            padding: 16px;
          }

          .name {
            float: left;
            @include fontPrimary400();
            font-size: 16px;
            padding: 16px 0;
          }

          .chevron {
            float: right;
            padding: 16px;
          }

          &:hover {
            
            .tool-icon {
              color: $black87;
            }            
            
            .chevron {
              color: $black87;
            }

          }

        }

      }

    }

    .unit-type {

      position: relative;
      height: 50px;      
      border-bottom: $borderBlack12;

      .name {
        @include fontPrimary400;
        @include textEllipsis;
        
        position: absolute;
        top: 12px;
        left: 16px;
        right: 100px;
      }
      
      .buttons {
        position: absolute;
        top: 4px;
        right: 8px;

        .vo-icon-button {
          float: left;
          margin: 0 0 0 4px;
        }

      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/PropertyDetails.vue